import { render, staticRenderFns } from "./DemographicQuestionsPopup.vue?vue&type=template&id=31da67c1&"
import script from "./DemographicQuestionsPopup.vue?vue&type=script&lang=ts&"
export * from "./DemographicQuestionsPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports